import { useState } from "react";

interface ShareButtonProps {
  title: string;
  className?: string;
}

export default function ShareButton({ title, className = "" }: ShareButtonProps) {
  const [toast, setToast] = useState("");

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.share) {
        await navigator.share({ title, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      setToast("链接已复制到剪贴板");
      setTimeout(() => setToast(""), 2200);
    } catch {
      setToast("复制失败，请手动复制地址栏链接");
      setTimeout(() => setToast(""), 2200);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleShare}
        className={`h-10 px-4 flex items-center gap-2 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-accent-300 hover:text-accent-600 transition-colors ${className}`}
      >
        <i className="ri-share-line" />
        分享
      </button>
      {toast && (
        <div className="fixed left-1/2 -translate-x-1/2 bottom-8 z-[80] px-4 py-2 rounded-md bg-foreground-950 text-background-50 text-sm kuisi-fade">
          {toast}
        </div>
      )}
    </>
  );
}